<template>
    <div
        class="a-icon"
        :style="[
            width ? { width: width } : {},
            height ? { height: height } : {}
        ]"
        :class="iconClass"
    >
        <component :is="`Icon${icon}`" v-bind="{ ...$props, ...iconConfig }" />
    </div>
</template>

<script>
import Vue from 'vue'

const requireComponent = require.context('../icons', false, /[\w]+\.vue$/)

// register each component
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName)
    // remove from filename './' from beginning, '.vue' at the end
    const componentName = `Icon${fileName
        .substr(0, fileName.length - 4)
        .substr(2)}`
    // register component
    Vue.component(componentName, componentConfig.default || componentConfig)
})

export default {
    name: 'AIcon',
    props: {
        iconConfig: {
            type: Object,
            default: () => {}
        },
        icon: {
            type: String,
            required: true
        },
        iconClass: {
            type: String,
            required: false
        },
        width: {
            type: String,
            required: false
        },
        height: {
            type: String,
            required: false
        },
        color: {
            type: String,
            required: false
        }
    }
}
</script>
